import {Document} from '../../models/document.model';
import {ValidationError} from '../../models/validation-error.model';
import {DocumentListFilter} from '../../models/document-list-filter.model';
import {SearchQueryParams} from '../../models/search-query-params.model';

export namespace DocumentActions {
    export class GetById {
        static readonly type = 'DocumentActions.GetById';

        constructor(public id: number) {
        }
    }

    export class GetListPage {
        static readonly type = 'DocumentActions.GetListPage';

        constructor(public params?: SearchQueryParams) {
        }
    }

    export class Add {
        static readonly type = 'DocumentActions.Add';

        constructor(public readonly document: Document) {
        }
    }

    export class Update {
        static readonly type = 'DocumentActions.Update';

        constructor(public readonly document: Document) {
        }
    }

    export class Delete {
        static readonly type = 'DocumentActions.Delete';

        constructor(public readonly document: Document) {
        }
    }

    export class FormFailure {
        static readonly type = 'DocumentActions.FormFailure';

        constructor(public readonly validationErrors: ValidationError[]) {
        }
    }

    export class FieldList {
        static readonly type = 'DocumentActions.DocumentFieldList';

        constructor(public readonly paramsList?: DocumentListFilter) {
        }
    }

    export class OwuList {
        static readonly type = 'DocumentActions.OwuList';
    }

    export class AttachmentsList {
        static readonly type = 'DocumentActions.AttachmentsList';
    }
}
